/**
 * @flow
 */

import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { search, filterBySalons } from '../../../actions/inventory';
import { map } from 'lodash';

import InventoryMenu from '../components/InventoryMenu';

import type { Dispatch } from '../../../type';

const mapStateToProps = ({ inventory }) => ({
    searchQuery: inventory.get('searchQuery'),
    salonFilter: inventory.get('salonFilter'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onSearch: (e, { value }) => {
        dispatch(search(value));
    },
    onSalonSelect: (e, { value }) => {
        dispatch(filterBySalons(value));
    },
});

function InventoryMenuContainer(props) {
    const { salons } = props;

    const salonOptions = useMemo(
        () =>
            map(salons, ({ id, name, address }) => ({
                text: name,
                value: id,
                description: address,
            })),
        [salons],
    );

    return <InventoryMenu {...props} salonOptions={salonOptions} />;
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(InventoryMenuContainer);
